/* Filtres par sujet et « voir plus » d'une liste d'avis (nky-avis-liste, 31/10/2026). Un bouton de filtre garde les avis
   dont les sujets (data-sujets, séparés par des virgules) contiennent son nom ; le premier bouton (data-filtre vide) les garde
   tous. « Voir plus » montre « limite » avis de plus parmi ceux du filtre. Chargé par chaque liste : s'installe une fois. */
(function () {
  if (window.nkyAvisFiltres) return;
  window.nkyAvisFiltres = true;

  function appliquer(zone) {
    var filtre = zone.dataset.filtre || '';
    var limite = parseInt(zone.dataset.limite, 10) || 0;
    var montres = parseInt(zone.dataset.montres, 10) || limite;
    var n = 0, retenus = 0;
    zone.querySelectorAll('.nky-avis-liste > .shopify-block').forEach(function (bloc) {
      var carte = bloc.querySelector('.nky-avis');
      var sujets = ((carte && carte.dataset.sujets) || '').split(',').map(function (x) { return x.trim(); });
      var garde = !filtre || sujets.indexOf(filtre) !== -1;
      if (garde) { retenus++; if (limite && n >= montres) garde = false; else n++; }
      bloc.classList.toggle('is-filtre-cache', !garde);
    });
    var plus = zone.querySelector('[data-nky-avis-plus]');
    if (plus) plus.hidden = !(limite && retenus > montres);
    var liste = zone.querySelector('.nky-avis-liste');
    if (liste) liste.scrollLeft = 0;
  }

  function installer() {
    document.querySelectorAll('[data-nky-avis-filtres]').forEach(function (zone) {
      if (zone.dataset.nkyPret) return;
      zone.dataset.nkyPret = '1';
      appliquer(zone);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.nky-avis-filtres__bouton');
    var p = e.target.closest('[data-nky-avis-plus]');
    var zone = (b || p) && (b || p).closest('[data-nky-avis-filtres]');
    if (!zone) return;
    if (b) {
      zone.querySelectorAll('.nky-avis-filtres__bouton').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      zone.dataset.filtre = b.dataset.filtre || '';
      zone.dataset.montres = zone.dataset.limite;
    } else {
      zone.dataset.montres = (parseInt(zone.dataset.montres, 10) || parseInt(zone.dataset.limite, 10)) + (parseInt(zone.dataset.limite, 10) || 0);
    }
    appliquer(zone);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installer); else installer();
  document.addEventListener('shopify:section:load', installer);
  document.addEventListener('shopify:block:select', installer);
})();
